import React from 'react';
import styled from 'styled-components';
import { Caption1 } from '../../../components/Typography';
import Icon from './Icon';
import { Wrapper, Text, IconWrapper, Image } from '../styles';
import TrackButton from './TrackButton';
import appConfig from '../../../../app-config';
import moment from 'moment';
import { DELIVERY, PICKUP } from '../../OrderSetting/orderSettingTypes';

const Content = styled.div`
  display: grid;
  grid-gap: 4px;
  @media (max-width: 479px) {
    .hideResponsive{
      display:none !important;
    }
  }
`;

const TimeText = styled(Caption1)`
  font-size: 13px;
  color: ${(props) => props.theme.orderStatusTimeTextColor};
`;

const TrackButtonWrapper = styled.div`
  display: none;

  @media (max-width: 479px) {
    display: block;
  }
`;

const EstimetedTimeContent = styled(Caption1)`
  display: inline-block;
  color: ${(props) => props.theme.orderStatusTimeTextColor};
`;

const OrderAccepted = ({ orderStatus, orderType, isOrderStatusModal }) => {
  let estimatedPickUpTime;
  const tomorrow = moment().add(1, 'day');

  if ('delivery_tracking_url' in orderStatus) {
    estimatedPickUpTime = moment(orderStatus.order_date);
  } else {
    if (orderStatus.is_future_order) {
      estimatedPickUpTime = moment(orderStatus.order_date);
    } else {
      estimatedPickUpTime = moment(orderStatus.order_date).add(
        moment.duration(orderStatus.estimated_time).asSeconds(),
        'seconds'
      );
    }
  }

  const isFeastifyDeliveryOrder =
    appConfig.appSource === 'feastify' && orderStatus.order_type === DELIVERY;

  return (
    <Wrapper>
      <IconWrapper>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gridGap: '10px',
            alignItems: 'center'
          }}
        >
          {appConfig.orderStatusImages &&
          appConfig.orderStatusImages.order_accepted ? (
            <Image src={appConfig.orderStatusImages.order_accepted} />
          ) : (
            <Icon
              className={
                (appConfig.orderStatusIcons &&
                  appConfig.orderStatusIcons.order_accepted) ||
                'fas fa-hat-chef'
              }
            />
          )}
          {orderStatus.delivery_tracking_url &&
          orderStatus.order_type !== DELIVERY &&
          appConfig.appSource !== 'feastify' ? (
            <TrackButton
              id="OrderAccepted-TrackButton"
              orderStatus={orderStatus}
            />
          ) : null}
        </div>
      </IconWrapper>

      <Content>
        <Text id="OrderAccepted-OrderInProgress">
          {!isFeastifyDeliveryOrder
            ? 'Your order is being prepared.'
            : 'Your order has been accepted.'}
        </Text>
        {orderStatus && !isFeastifyDeliveryOrder && (
          <Text id="OrderSubmitted-EstimatedTime">
            Estimated Time:{' '}
            {estimatedPickUpTime.isSame(tomorrow, 'day') ? (
              <EstimetedTimeContent>
                {moment(estimatedPickUpTime, 'YYYY-MM-DD HH:mm:ss').format(
                  'hh:mm A'
                )}{' '}
                Tomorrow
              </EstimetedTimeContent>
            ) : estimatedPickUpTime.isSame(moment(), 'day') ? (
              <EstimetedTimeContent>
                {moment(estimatedPickUpTime, 'YYYY-MM-DD HH:mm:ss').format(
                  'hh:mm A'
                )}
              </EstimetedTimeContent>
            ) : (
              <EstimetedTimeContent>
                {moment(estimatedPickUpTime, 'YYYY-MM-DD HH:mm:ss').format(
                  'ddd  MMM DD - hh:mm A'
                )}
              </EstimetedTimeContent>
            )}
          </Text>
        )}
        {orderStatus.delay ? (
          <Text  className={`${isOrderStatusModal ? "" : "hideResponsive"}`}>
            {`(Delayed by ${orderStatus.delay} ${
              orderStatus.delay === 1 ? 'min' : 'mins'
            }. Contact store for more info.)`}
          </Text>
        ) : null}
        {orderStatus &&
          orderStatus.delivery_tracking_url &&
          !isFeastifyDeliveryOrder && (
            <TrackButtonWrapper>
              <TrackButton
                id="OrderAccepted-TrackButtonOrder"
                orderStatus={orderStatus}
              />
            </TrackButtonWrapper>
          )}
      </Content>
    </Wrapper>
  );
};

export default OrderAccepted;
